import { ShowAllResultPanelController } from './show-all-results-panel.controller';
import { ShowAllResultPanelProps } from './show-all-results-panel.model';

export const ShowAllResultPanel = (props: ShowAllResultPanelProps) => {
  return <ShowAllResultPanelController {...props} />;
};
